import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowMuiIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M7 10l5 5 5-5z"></path>
    </SvgIcon>
);
